import classNames from 'classnames';
import Info from '../../components/common/Info';
import GapAround from '../../components/hoc/GapAround'
import { imageUrl } from '../../utils';

const TrustedBySection = () => {

  const trustedCompanies = [
    {
      src: imageUrl('everyday_inclusion_logo.webp'),
      alt: 'Everyday Inclusion logo',
    },
    {
      src: imageUrl('lead_autopilot.webp'),
      alt: 'Lead Autopilot logo',
    },
    {
      src: imageUrl('apexcare_logo.webp'),
      alt: 'Apexcare logo',
    },
    {
      src: imageUrl('ares_logo.webp'),
      alt: 'Ares logo',
    },
    {
      src: imageUrl('upkeep_logo.webp'),
      alt: 'Upkeep logo',
    },
    {
      src: imageUrl('extuitive_logo.webp'),
      alt: 'Extuitive logo',
    },
    {
      src: imageUrl('eventrender_logo.png'),
      alt: 'eventrender logo',
    },
    {
      src: imageUrl('poppynotes_logo.png'),
      alt: 'poppynotes logo',
    },
    {
      src: imageUrl('tald_logo.png'),
      alt: 'TALD logo',
    },
    {
      src: imageUrl('homeworks_logo.webp'),
      alt: 'HOMEWORKS logo',
    },
    {
      src: imageUrl('nestbuilder_logo.png'),
      alt: 'NESTBUILDER logo',
    },
    {
      src: imageUrl('scholastic_logo.png'),
      alt: 'Alliance for Young Artists & Writers and Scholastic Art & Writing Awards logo',
    },
  ];
  return (
    <div className={classNames('pb-14 border-y-2 border-t-0 breaktwo:pb-8')}>
      <GapAround>
        <Info variant={'h2'} className="lg:!text-[36px] md:!text-[28px] !text-[28px]"
          typographyStyles={{ fontWeight: 500}}
          containerClasses={'text-center mb-6 md:mb-16'}>
          {'Trusted by top companies'}
        </Info>
        <div className="trusted-marquee overflow-hidden mt-0 md:-mt-10">
          <div className="trusted-marquee-track flex items-center w-max">
            {[...trustedCompanies, ...trustedCompanies].map((each, index) => {
              const isClone = index >= trustedCompanies.length;
              return (
                <div
                  key={`trusted${index}`}
                  aria-hidden={isClone}
                  className="flex shrink-0 justify-center items-center h-12 md:h-14 lg:h-16 mx-5 md:mx-8">
                  <img
                    loading="lazy"
                    src={each.src}
                    className="h-full w-auto max-h-full max-w-[120px] md:max-w-[150px] lg:max-w-[170px] object-contain"
                    alt={isClone ? '' : each.alt}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </GapAround>
    </div>
  );
};

export default TrustedBySection;
